export const black = '#000000';
export const white = '#ffffff';
export const chambray = '#2e4487';
